import { render, staticRenderFns } from "./FormProgramActivityReminderImport.vue?vue&type=template&id=5435df8f&scoped=true"
import script from "./FormProgramActivityReminderImport.vue?vue&type=script&lang=js"
export * from "./FormProgramActivityReminderImport.vue?vue&type=script&lang=js"
import style0 from "./FormProgramActivityReminderImport.vue?vue&type=style&index=0&id=5435df8f&prod&lang=scss&scoped=true"
import style1 from "./FormProgramActivityReminderImport.vue?vue&type=style&index=1&id=5435df8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5435df8f",
  null
  
)

export default component.exports